import moment from 'moment';
import toMomentObject from './toMomentObject';

export default function toUtcDate(date) {
  const dateObj = moment.isMoment(date) ? date : toMomentObject(date);
  if (!dateObj) return null;

  return new Date(
    Date.UTC(
      dateObj.year(),
      dateObj.month(),
      dateObj.date(),
      dateObj.hour(),
      dateObj.minute(),
      0
    )
  );
}
